var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M15 1H1v14h14zm1-1v16H0V0z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M7.775 12h.89v-.89h-.89zm.639-7.232a1.417 1.417 0 0 1 1.59 1.317c0 .828-1.14 1.614-1.754 2.361-.247.236-.404.55-.444.889v.889s.889.01.889 0v-.889c0-.227.246-.432.444-.669.59-.708 1.689-1.439 1.689-2.58A2.245 2.245 0 0 0 8.414 4 2.44 2.44 0 0 0 6 5.756l.713.219a1.66 1.66 0 0 1 1.7-1.207z",
  clipRule: "evenodd"
})));
export default SvgQuestionmark;